import { useQuery } from '@tanstack/react-query'
import { getLineItemReturnReasons } from '@/api/processes-api'
import { toProcessEcommerceScope } from './process-ecommerce-scope'

export const useLineItemReturnReasons = (ecommerceIds?: string[]) => {
  return useQuery({
    queryKey: ['line-item-return-reasons', ecommerceIds],
    queryFn: async ({ signal }) => {
      const response = await getLineItemReturnReasons(
        {
          pbFindLineItemReturnReasonsRequest:
            toProcessEcommerceScope(ecommerceIds)
        },
        signal
      )
      return response.return_reasons ?? []
    },
    staleTime: Infinity
  })
}
